// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';
import 'select2/dist/js/select2.full.js'

/**
 * Nápověda pro zápis konfigurace do datasetu pro jednotlivé komponenty (nemusí fungovat pro všechny zapsané vlastnosti)
 * data-options='{"key": "value", "key": "value"}'
 * https://select2.org/configuration/options-api
 */

export default class SelectDesign extends WebComponent {
	constructor(props) {
		super(props);

		this.options = this.props.options || {};
	}

	didMount() {
		$(this.element).select2({
			minimumResultsForSearch: Infinity,
			...this.options,
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/SelectDesign.js